<template>
  <div class="content content--gtm-single">
    <MyHeader :breadcrumbItems="[
        {
          name: section.name,
          path: `/${$route.params.companySlug}/clients`
        },
        {
          name: client.name,
          path: $route.path
        },
      ]"/>

    <header class="content-header d-lg-none">
      <h1>{{client.name}}</h1>
    </header>

    <div class="container main-content">
      <div class="hero--gtm">
        <div class="hero-logo">
          <ImageWrapper :file='client.idLogo' :key="client.idLogo"></ImageWrapper>
        </div>
        <div class="hero-content">
          <span class="hero-tag">
            <span>{{client._embedded.Country.value}}</span>
            <span>{{client._embedded.Category.value}}</span>
            <span class="box-sector">{{client._embedded.Sector.value}}</span>
          </span>
          <Bookmark :contentId="client.idContent"></Bookmark>
          <span class="hero-title">{{client.name}}</span>
          <p v-html="client.headline"></p>
          <div class="buttons" v-if="client.URL">
            <a target="_blank" :href="client.URL">
              <button class="button-icon">Visit website <i class="icon-external"></i></button>
            </a>
          </div>
        </div>
      </div>

      <div class="article-content row">
        <div class="col-lg-10 offset-lg-1" v-html="client.contentClient">
        </div>
      </div>

      <div class="main-content-bottom2 row">
        <div class="col-lg-10 offset-lg-1">
          <div class="main-content-bottom2-title">ABM Lead</div>
          <div class="row boxes-row">
            <div class="col-lg-4" v-for="contact in client._embedded.TeamMembers" :key="contact.idTeamMember">
              <TeamMemberBox :box="contact" :hideDetails="true" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '../../components/general/Header'
import ImageWrapper from "@/components/general/ImageWrapper";
import TeamMemberBox from "@/components/persons/TeamMemberBox";
import Bookmark from "@/components/general/Bookmark";
import userApi from "@/api/user";

export default {
  name: "ClientSingle",
  components: {Bookmark, TeamMemberBox, ImageWrapper, MyHeader },

  computed: {
    client() {
      return this.$store.getters.client
    },
    section() {
      return this.$store.getters.menu().find((item) => {
        return item.routeName === 'Clients'
      })
    },
  },
  mounted() {
    this.getClient()
  },
  watch: {
    '$route.params.id'() {
      this.getClient()
      this.$nextTick(() => {
        let mainDiv = document.getElementsByClassName("content--gtm-single");
        if(mainDiv) {
          mainDiv[0].scrollIntoView({behavior: 'smooth'})
        }
      })
    },
    '$store.getters.clientLoaded' (val) {
      if(val) {
        window._paq.push(['setDocumentTitle', this.client.name]);
        window._paq.push(['trackPageView']);
        userApi.logUserAccessContent({
          "idContent": this.client.idContent,
          "idUser": this.$store.getters.user.idUser,
          "idUserAccessContent":""
        })
      }
    }
  },
  methods: {
    getClient() {
      this.$store.dispatch('getClient', {
        _embed: 1,
        _page: 1,
        _per_page: 1,
        idClient: this.$route.params.id
      })
    }
  }
}
</script>
